import { Flex, Modal, Modal as ModalMantine } from "@mantine/core";

interface IProps {
  title?: string;
  open: boolean;
  setClose: () => void;
  children: React.ReactNode;
  full?: boolean;
}

export default function ModalTable({
  title,
  open,
  setClose,
  children,
  full = false,
}: IProps) {
  return (
    <ModalMantine
      size={full ? "full" : ""}
      opened={open}
      onClose={setClose}
      transitionProps={{
        exitDuration: 600,
        transition: "slide-up",
        duration: 600,
        timingFunction: "ease",
      }}
      withCloseButton={false}
      centered
      styles={{
        content: {
          borderRadius: "12px",
          maxWidth: "1680px !important",
          width: "100%",
        },
        header: {
          marginBottom: "0",
          background: "transparent",
          padding: "20px 0",
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
        },
        root: {
          width: "100%",
        },
        close: {
          display: "flex",
          height: "28px",
          width: "28px",
          justifyContent: "center",
          alignItems: "center",
          svg: {
            height: "24px !important",
            width: "24px !important",
          },
        },
        body: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          backgroundColor: "#fff",
          borderRadius: "50px 50px 12px 12px",
          padding: "0 40px 40px 40px",
        },
      }}
    >
      <Modal.Header>
        {title ? title : "Escolha qual ação deseja realizar"}
        <Modal.CloseButton />
      </Modal.Header>
      <Flex gap="16px" direction={"column"} w="100%">
        {children}
      </Flex>
    </ModalMantine>
  );
}
